import React from 'react';

function IssuerPortal() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">Issuer Portal</h1>
      <p>Here you can assign certifications and manage users.</p>
    </div>
  );
}

export default IssuerPortal;
